<template>
  <div>
    <view-table
        ref="viewTable"
        :limits="limits"
        :columns-property="columnsProperty"
        :filter="filter"
        module="basic"
        url="packMarkDetails"
        @reset="resetHandle"
        @delete="deleteHandle"
        @select="selectHandle"
        @addOrEdit="addEditHandle">
      <template slot="otherBtn">
        <el-button v-if="submitAuth" type="primary" :disabled="!selection.length" @click="submit"> 审核</el-button>
        <el-button v-if="cancelAuth" type="primary" :disabled="!selection.length" @click="repeal"> 撤销</el-button>
        <el-button v-if="printAuth" type="primary" :disabled="!selection.length" @click="printOutStockOrder">打印
        </el-button>
      </template>
      <template slot="adSearch">
        <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
          <el-form-item label="装箱单编号">
            <el-input v-model.trim="filter.billNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="装箱单条码">
            <el-input v-model.trim="filter.packBarcode" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="制单人">
            <el-input v-model.trim="filter.creatorName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料名称">
            <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="物料编号">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="规格型号">
            <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
          </el-form-item>
          <el-form-item label="关联单据">
            <el-input v-model.trim="filter.refBillNo" placeholder="请输入" clearable/>
          </el-form-item>
          <!--          <el-form-item label="要求日期">-->
          <!--            <el-date-picker-->
          <!--                v-model="requireDateRange"-->
          <!--                type="daterange"-->
          <!--                range-separator="至"-->
          <!--                start-placeholder="开始时间"-->
          <!--                end-placeholder="结束时间"-->
          <!--                value-format="yyyy-MM-dd"-->
          <!--                @change="dateRangeChange('requireDateRange', 'requireDateBegin', 'requireDateEnd')"/>-->
          <!--          </el-form-item>-->
          <el-form-item label="制单日期">
            <el-date-picker
                v-model="createDateRange"
                type="daterange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd"
                @change="dateRangeChange('createDateRange', 'createTimeBegin', 'createTimeEnd')"/>
          </el-form-item>
        </el-form>
      </template>
      <template slot="actionBtn" slot-scope="scope">
        <el-button v-if="limits.scanAuth" type="primary"
                   :disabled="scope.row.status !== 0"
                   @click="packHandle(scope.row)">
          装箱
        </el-button>
      </template>
    </view-table>
    <pack-mark-edit ref="editPage" @save-success="loadData(1)"/>
    <pack-mark-print ref="printPackMark" @save-success="loadData(1)"/>
    <pack-mark-detail-record ref="packRecord" @save-success="loadData(1)"/>
  </div>
</template>

<script>
import viewTable from "@/components/ViewTable.vue";
import PackMarkEdit from "./PackMarkEdit";
import PackMarkPrint from "@/views/DeliveryManage/PackMark/PackMarkPrint";
import PackMarkDetailRecord from "@/views/DeliveryManage/PackMark/PackMarkDetailRecord";

export default {
  name: "PackMarkDetailList",
  components: {
    viewTable,
    PackMarkEdit,
    PackMarkPrint,
    PackMarkDetailRecord,
  },
  data() {
    return {
      ids: [],
      mastIds: [],
      selection: [],
      requireDateRange: [],
      createDateRange: [],
      printAuth: this.$auth(749),
      submitAuth: this.$auth(750),
      cancelAuth: this.$auth(751),
      labelPrintAuth: this.$auth(749),
      limits: {
        // addAuth: this.$auth(299),
        delAuth: this.$auth(746),
        editAuth: this.$auth(745),
        scanAuth: this.$auth(748),
      },
      filter: {
        billNo: "",
        status: "",
        packBarcode: "",
        materialName: "",
        materialNo: "",
        specification: "",
        refBillNo: "",
        requireDateBegin: "",
        requireDateEnd: "",
        createTimeBegin: "",
        createTimeEnd: "",
        creatorName: "",
      },
      columnsProperty: [
        {
          width: 55,
          align: "center",
          type: "expand",
          fixed: "left",
          render: (h, params) => {
            return h("Table", {
              props: {
                data: params.row.recordVOS,
                columns: [
                  {
                    type: "index",
                    width: 55,
                    align: "center",
                  },
                  {
                    title: "追溯码",
                    key: "barcode",
                    width: 250,
                  },
                  {
                    title: "操作人",
                    key: "operatorName",
                    width: 150,
                  },
                  {
                    title: "操作时间",
                    key: "operateTime",
                    width: 160,
                  },
                ],
                border: true,
                stripe: true,
              },
            });
          },
        },
        {
          key: "packNo",
          align: "center",
          width: 140,
          render: (h, params) => {
            return h(
                "span",
                {
                  style: {
                    color: "#2d8cf0",
                    cursor: "pointer",
                  },
                  on: {
                    click: () => {
                      this.$refs.editPage.open(params.row.masterId, [], params.row.packType, true);
                    },
                  },
                },
                params.row.packNo,
            );
          },
        },
        {
          key: "action",
          align: "center",
          width: 200,
          fixed: "right",
          slot: "action",
        },
      ],
    };
  },

  watch: {
    // "filter.requireDateBegin": {
    //   handler(newVal) {
    //     if (newVal) {
    //       this.requireDateRange = [];
    //       this.requireDateRange.push(this.filter.requireDateBegin);
    //       this.requireDateRange.push(this.filter.requireDateEnd);
    //     }
    //   },
    // },
    "filter.createTimeBegin": {
      handler(newVal) {
        if (newVal) {
          this.createDateRange = [];
          this.createDateRange.push(this.filter.createTimeBegin);
          this.createDateRange.push(this.filter.createTimeEnd);
        }
      },
    },
  },
  methods: {
    loadData(pageNum) {
      this.$refs.viewTable.loadData(pageNum);
    },
    dateRangeChange(timeRange, timeStart, timeEnd) {
      if (this[timeRange]) {
        this.filter[timeStart] = this[timeRange][0];
        this.filter[timeEnd] = this[timeRange][1];
      } else {
        this.filter[timeStart] = "";
        this.filter[timeEnd] = "";
      }
    },
    addEditHandle(row) {
      if (row) {
        this.$refs.editPage.open(row.masterId, [], row.packType, false);
      }
    },

    selectHandle(selection) {
      this.ids = [];
      this.mastIds = [];
      this.selection = selection;
      this.selection.forEach((item) => {
        this.ids.push(item.pkid);
        this.mastIds.push(item.masterId);
      });
    },
    packHandle(row) {
      this.$refs.packRecord.open(row.pkId);
    },
    resetHandle(filter) {
      this.filter = Object.assign(this.filter, filter);
    },

    // 提交
    submit() {
      const arr = this.selection.filter((item) => item.packStatus !== 0);
      if (arr.length) {
        this.$confirm("请选择未审核的订单", "错误", {
          type: "error",
          showCancelButton: false,
        });
      } else {
        this.$confirm("确定审核吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "packMarks/approve", this.mastIds).then(() => {
            this.loadData(1);
            // this.$message.success("审核成功");
            this.selection = [];
          });
        });
      }
    },

    // 撤销
    repeal() {
      const arr = this.selection.filter((item) => item.packStatus !== 20);
      if (arr.length) {
        this.$confirm("请选择已审核的订单", "错误", {
          type: "error",
          showCancelButton: false,
        });
      } else {
        this.$confirm("确定撤销吗?", "提示", {type: "warning"}).then(() => {
          this.$http.post("basic", "packMarks/cancel", this.mastIds).then(() => {
            this.loadData(1);
            // this.$message.success("撤销成功");
            this.selection = [];
          });
        });
      }
    },

    // 打印装箱单
    printOutStockOrder() {
      const arr = this.selection.filter((item) => item.packStatus == 0);
      if (arr.length) {
        this.$confirm("请选择已审核的订单", "错误", {
          type: "error",
          showCancelButton: false,
        });
        return;
      }
      this.$refs.printPackMark.open(this.selection);
    },

    // 单个删除
    deleteHandle(row) {
      this.$http.delete("basic", "packMarks", row.masterId).then((resp) => {
        if (resp.success) {
          this.loadData(1);
          this.$message.success("删除成功");
          this.selection = [];
        }
      });
    },

    // 批量删除
    deleteBatch() {
      const arr = this.selection.filter((item) => item.status !== 0);
      if (arr.length) {
        this.$confirm("请选择未提交状态的订单", "错误", {
          type: "error",
          showCancelButton: false,
        });
        return;
      }
      this.$confirm("确定删除吗?", "提示", {type: "warning"}).then(() => {
        this.$http.post("basic", "packMarks/deleteBatch", this.ids).then((resp) => {
          if (resp.success) {
            this.loadData(1);
            this.$message.success("删除成功");
            this.selection = [];
          }
        });
      });
    },
    transferEdit() {
      const labelData = {
        pkid: this.selection[0].pkid,
        transferCompany: "广昌县恒达（彤宏）物流有限公司",
        transferWeight: "",
        transferNo: "",
        transferNote: "",
      };
      this.contentLoading = true;
      this.$http
          .get("basic", `outStockDeliverys/${labelData.pkid}`)
          .then((resp) => {
            if (resp.success) {
              labelData.transferCompany = resp.data.transferCompany;
              labelData.transferWeight = resp.data.transferWeight;
              labelData.transferNo = resp.data.transferNo;
              labelData.transferNote = resp.data.transferNote;
              this.contentLoading = false;
            }
          })
          .catch(() => {
            this.contentLoading = false;
          });

      this.$refs.transferEdit.open(labelData);
    },


    otherAuth(row) {
      if (row.packStatus === 0) {
        return {
          editAuth: false,
          delAuth: false,
        };
      } else {
        return {
          editAuth: true,
          delAuth: true,
        };
      }
    },
  },
};
</script>

<style>

</style>